const wowApp = require('angular').module('wowApp.common');

wowApp.service('UnsubscribeEdmService', ['Restangular', require('./unsubscribe-edm.service')]);

wowApp.directive('wowUnsubscribeEdm', ['UnsubscribeEdmService', 'Settings', '$state', '$sce', '$timeout', require('./unsubscribe-edm.directive')]);



// WEBPACK FOOTER //
// ./src/common/unsubscribeedm/index.js